import { getAttributionExpiry } from "../data";
import { SoftwallRecoveredType } from "../types";
import { isExpired, getExpiryTimeFromDays } from "../utils";

export const isSessionRecovered = (
  recovered: SoftwallRecoveredType,
  attributionWindow: number,
) => {
  // get expiration time if already set or get new one based on attribution window
  const attributionExpiry =
    getAttributionExpiry() || getExpiryTimeFromDays(attributionWindow);

  const isExpiredV = isExpired(attributionExpiry);
  const isRecovered = recovered === "AB" || recovered === "SCA";

  return { isActive: isRecovered && !isExpiredV, attributionExpiry };
};
